import { createContext, useContext, useState } from 'react';

const BriefGiveawayFormContext = createContext();

const initialState = {
  isOpenModalSelectProduct: false,
  activeGiveawayIndex: null,
  selectedImagePreview: [],
  isOpenImagePreview: false,
};

const initialFilterState = {
  search: '',
  limit: 10,
  page: 1,
};

const BriefGiveawayFormProvider = ({ children }) => {
  const [state, setState] = useState(initialState);
  const [filterState, setFilterState] = useState(initialFilterState);

  const updateState = (payload) => setState((prev) => ({ ...prev, ...payload }));
  const resetState = () => setState(initialState);
  const updateFilterState = (payload) => setFilterState((prev) => ({ ...prev, ...payload }));

  return (
    <BriefGiveawayFormContext.Provider value={{ updateState, resetState, state, updateFilterState, filterState }}>{children}</BriefGiveawayFormContext.Provider>
  );
};

export const useBriefGiveawayFormState = () => {
  return useContext(BriefGiveawayFormContext);
};

export default BriefGiveawayFormProvider;
